import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-textile-model-category3',
  templateUrl: './textile-model-category3.component.html',
  styleUrls: ['./textile-model-category3.component.css']
})
export class TextileModelCategory3Component implements OnInit {
    public textileModelCategory3Keyno: string;

    public languageNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'textilemodelcategory3lang', gotoParms: () => this.edit!.textilemodelcategory3_keyno ?? '' }];

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.textileModelCategory3Keyno = this.stateService.getStateParams()['textilemodelcategory3_keyno'];
    }

    private async loadEdit() {
        if (!!this.textileModelCategory3Keyno) {
            this.edit = (await this.datatask.Post(2676, { textilemodelcategory3_keyno: this.textileModelCategory3Keyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2677, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    textilemodelcategory3_keyno: string;
    textilemodelcategory3lang_name: string;
}
